import React, { useState, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    styled,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
    Chip
} from '@mui/material';

import { useNavigate, useParams } from "react-router-dom";
import { useUsers, userTypes, targetTypes } from "../../../hooks/api/useUsers";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useTranslations } from '../../../hooks/useTranslations';

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonRestricted from "../../common/CommonRestricted";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledContent2 = styled(Typography)(({ theme }) => ({
    fontSize: '0.8rem',
    mt: 2
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

export default function ViewWorker({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@user"] })

    const { id } = useParams();

    const { setSystemLoading } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { get: getUser } = useUsers({ userType: userTypes.worker, targetType: targetTypes.worker });
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.user.id, scopeTypes.user.worker.id)

    const navigate = useNavigate();
    const [data, setData] = useState()

    const fetchData = async () => {

        setSystemLoading(true);

        try {

            let response = await getUser({ id, dataTypesArray: ["zone"] });

            console.log('worker', response?.data)

            setData(response?.data)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        fetchData();

    }, [])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
            props.push({
                displayText: t("editProfile"),
                href: getRoute(`users/worker/update/${id}`)
            })
        }

        return props

    }

    const RenderFormProfile = () => {

        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`workerProfileDetails`)}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('username')}</StyledLabel>
                            </Grid>

                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.worker?.username}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('name')}</StyledLabel>
                            </Grid>

                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {`${data?.worker?.firstname} ${data?.worker?.lastname}`}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('contact')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.worker?.contact}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('email')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.worker?.email}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>{t('locationPermissions')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {data?.worker?.location_name}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormZone = () => {

        let zones = data?.worker?.zones
        
        return (
            <Grid container spacing={0.5}> 
                <Grid item xs={6} sm={6} md={12} display={"flex"} justifyContent={"flex-start"} alignItems={"left"} sx={{ml: 1}}>
                    <CommonSectionHeader
                        title={t(`zones`)}
                        subTitle={t(`zoneAllocationArea`)}
                    />
                </Grid>

                {
                    (!zones?.length)?
                        <Grid item xs={12} sm={12} md={12} textAlign={"center"}>
                            <StyledCard
                                sx={{
                                    mt : 1,
                                    p : 0
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: 20,
                                        height: 100,
                                        textAlign: 'center',
                                        alignContent: 'center'
                                    }}
                                >
                                    {t('thereIsNoZoneBeenAssignedAtTheMoment')}
                                </Typography>
                            </StyledCard>
                        </Grid>
                        :
                        <>
                            <Grid item xs={12} sm={12} md={12} textAlign={"right"}>
                                <StyledCard
                                    sx={{
                                        mt : 1,
                                        p : 0
                                    }}
                                >
                                    <Grid container rowSpacing={0}>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <TableContainer>
                                                <Table
                                                    size="small"
                                                    stickyHeader
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell width={20}>#</TableCell>
                                                            <TableCell width={120}>{t('location')}</TableCell>
                                                            <TableCell width={120}>{t('zone')}</TableCell>
                                                            <TableCell width={120}>{t('rack')}</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {
                                                            zones?.map((item, index) => {

                                                                let rackName = []

                                                                item?.racks?.forEach(i => {
                                                                    rackName.push(i?.rack_name)
                                                                })

                                                                return(
                                                                    <TableRow key={index}>
                                                                        <TableCell>{(index + 1)}</TableCell>
                                                                        <TableCell>{item?.location_name}</TableCell>
                                                                        <TableCell>{item?.zone_name}</TableCell>
                                                                        <TableCell>{rackName.join(',  ')}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                </StyledCard>

                            </Grid>
                        </>
                }
            </Grid>
        )
    }

    const RenderForm = () => {
        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                        <RenderFormProfile />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                        <RenderFormZone />
                    </Grid>
                </Grid>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"center"}>
                        <Button
                            type="button"
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            onClick={() => navigate(-1)}
                        >
                            {t('back')}
                        </Button>
                    </Grid>
                </Grid>
            </>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.viewWorker })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('viewWorker')}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("workers"),
                        props: {
                            // underline: "hover",
                            href: getRoute("users/workers")
                        }
                    },
                    {
                        displayText: t("viewWorker"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    (
                        <RenderForm />
                    )
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}